import { render } from "./GsdPopper.vue?vue&type=template&id=68bc1d4c"
import script from "./GsdPopper.vue?vue&type=script&lang=js"
export * from "./GsdPopper.vue?vue&type=script&lang=js"

import "./GsdPopper.vue?vue&type=style&index=0&id=68bc1d4c&lang=css"

import exportComponent from "/var/www/html/projects/rde/resources/vueapps/quotation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__